import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { WINDOW } from 'moddy/common';
import { ButtonModule } from 'primeng/button';
import { TooltipModule } from 'primeng/tooltip';

@Component({
    selector: 'app-contact-us-float-button',
    imports: [ButtonModule, TooltipModule],
    templateUrl: './contact-us-float-button.component.html',
    styleUrl: './contact-us-float-button.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContactUsFloatButtonComponent {
    private readonly window = inject(WINDOW);

    protected onClick(): void {
        this.window.open('https://t.me/moddyai', '_blank');
    }
}
